module.exports = __webpack_public_path__ + "img/luistorres-keyboard.30aa15f8.png";